import { render, staticRenderFns } from "./consignContract.vue?vue&type=template&id=552a8ab1&scoped=true&"
import script from "./consignContract.vue?vue&type=script&lang=js&"
export * from "./consignContract.vue?vue&type=script&lang=js&"
import style0 from "./consignContract.vue?vue&type=style&index=0&id=552a8ab1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a8ab1",
  null
  
)

export default component.exports